module.exports = __webpack_public_path__ + "static/media/reactNative_courseImage.38bc21ce.jpeg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/reactNative_courseImage.jpeg
 ** module id = 156
 ** module chunks = 0
 **/